import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

export default function ResourceOptions({ resources, resourceIDs }) {
  if (isEmpty(resources) || isEmpty(resourceIDs)) {
    return null;
  }

  return resourceIDs.map((resourceID) => {
    const resource = resources[resourceID];
    const { name, id } = resource;
    return (
      <option value={id} key={`resources.${name}.option.${id}`}>
        {name}
      </option>
    );
  });
}

ResourceOptions.propTypes = {
  resources: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ).isRequired,
  resourceIDs: PropTypes.arrayOf(PropTypes.number).isRequired,
};
